import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const MainLayout = ({ children, screenName }) => {
  return (
    <div>
      <Header />
      <div style={{ display: "flex" }}>
        <Sidebar screenName={screenName} />
        <div className="mainlayout-children">{children}</div>
      </div>
    </div>
  );
};

export default MainLayout;
